var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resultPage"},[_c('div',{staticClass:"content"},[_c('img',{attrs:{"src":require("@/assets/style/certification-icon.png"),"alt":""}}),_c('span',[_vm._v("正在获取认证结果")]),_c('span',[_vm._v("请耐心等待，请勿离开")])])])
}]

export { render, staticRenderFns }